import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import VueCookies from "vue-cookies";

Vue.use(Vuex);
Vue.use(VueCookies);

const store = new Vuex.Store({
  state: {
    loading: "true",
    user: {
      name: "Yusuf",
      id: 89
    },
    loader: false,
    requestDialog: false,
    products: [],
    storeProducts: [],
    store: '',
    business: 'false',
  },
  mutations: {
    SET_LOADING_STATUS(state, status) {
      state.loading = status;
    },
    SET_STORE(state, payload) {
        state.store = payload
    },
    SET_NAME(state, user) {
      state.user = user;
    },
    SET_LOADER(state, payload) {
      state.loader = payload;
    },
    SET_REQUEST_DIALOG(state, payload) {
      state.requestDialog = payload;
    },
    SET_PRODUCTS(state, payload) {
        state.products = payload
    },
    SET_STORE_PRODUCTS(state, payload) {
        state.storeProducts = payload
    },
    DELETE_PRODUCT(state, payload) {
        const index = state.products.findIndex(product => (parseInt(product.id) === parseInt(payload)))
        state.products.splice(index, 1)
    },
    SET_BUSINESS: (state, payload) => {
      state.business = payload
    }
  },
  actions: {
    loading(context, payload) {
      context.commit("SET_LOADING_STATUS", payload);
    },
    SET_LOADER(context, payload) {
      context.commit("SET_LOADER", payload);
    },
    SET_STORE(context, payload) {
      context.commit("SET_STORE", payload);
    },
    SET_REQUEST_DIALOG(context, payload) {
      context.commit("SET_REQUEST_DIALOG", payload);
    },
    SET_BUSINESS(context, payload) {
      axios.get(`https://apiideraos.com/api/product_listing/user_details/${payload}`, {
            headers: {Authorization: "Bearer " + window.$cookies.get("token")}
        })
        .then(res => {
            let r = res.data.body;
            let storeDone = false
            if(r.business_info != null) {
                storeDone = true;
                window.$cookies.set("business_info", 'true');
                window.$cookies.set("store_url", r.business_info.name);
            }else{
              storeDone = false;
              window.$cookies.set("business_info", 'false');
            }
            
            context.commit('SET_BUSINESS', storeDone)
        })
        .catch(function(error) {
            console.error(error);
        });
    },
    GET_PRODUCTS(context, payload) {
        const jwtHeader = {Authorization: "Bearer " + window.$cookies.get("token")}
        const user_phone = window.$cookies.get("phone");
        axios.get(`https://apiideraos.com/api/product_listing/get_products_by_owner/${user_phone}`, {
            headers: jwtHeader
        })
        .then(res => {
            var r = res.data;
            localStorage.setItem("productCount", r.body.length)
            context.commit('SET_PRODUCTS', r.body);
        })
        .catch(error => {
            console.log(error.response)       
        });
    },
    DELETE_PRODUCT(context, payload) {
        context.commit('DELETE_PRODUCT', payload)
    },
    GET_BANK(context, payload) {
          axios.get('https://apiideraos.com/api/product_listing/get_merchant_bank_account', {
                headers: {Authorization: "Bearer " + window.$cookies.get("token")}
          })
          .then(res => {
             // console.log(res.data)
          })
          .catch(error => {
              if(error.response.data.status_code === 200) {
                  //this.accountDetail = true
                  //this.bank_account = error.response.data.body
                  localStorage.setItem('isBank', true)
                  //context.commit('SET_BANK', error.response.data.body)
              }else if(error.response.data.status_code >= 400 && error.response.data.status_code <= 500){
                  localStorage.setItem('isBank', false)
              }
          })
    },
    GET_STORE_PRODUCTS(context, payload) {
        axios.get(`https://apiideraos.com/api/product_listing/get_products_by_owner_name/${payload}`)
        .then(res => {
            var r = res.data;
            let products = r.body.data;
            products = products.length > 0
                ? products.reverse()
                : products.reverse();
            
            const user_id = r.body.data[0].user_id;
            if (user_id !== Number(localStorage.getItem("current_store_owner_id"))) {
              localStorage.clear();
            }
            localStorage.setItem("current_store_owner_id", user_id);
            localStorage.setItem("single_store_url", payload);
            context.commit('SET_STORE_PRODUCTS', products);
        })
        .catch(error => {
            console.log(error.response)       
        });
    },
  },
  getters: {
    getusername: state => {
      return state.user.name;
    },
    getLoader: state => {
        return state.loader;
    },
    getRequestDialog: state => {
        return state.requestDialog;
    },
    getBusiness: state => {
        return state.business;
    },
    getProducts: state => {
        return state.products;
    },
    getStore: state => {
        return state.store;
    },
    getStoreProducts: state => {
        return state.storeProducts;
    }
  }
});

export default store;
